import React from 'react'
import utils from './utils'
import parser from '../../../../services/parser.services'

function getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, answer) {

    const commutative = commutative
    const width = gameContainerWidth
    const height = gameContainerHeight
    let { value_1 } = quantities
    const colWidth = width / 4
    const fontSize = colWidth
    let numbersLayout = null
    numbersLayout = (
        <text
            className="level-text-primary"
            fontSize={fontSize}
            fontWeight="regular"
            dominantBaseline="middle"
            x={colWidth * 2}
            y={height / 2}
            textAnchor="middle"
        >{value_1}</text>
    )
    return (
        <svg
            height={height}
            width={width}
        >
            {numbersLayout}
        </svg>
    )
}

export default {
    getLevelLayout,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/numberBond.utils.js